import React, { useState } from "react";
import SaleStepUserInfo from "../components/sale-step-user-info";
import SaleStepProducts from "../components/sale-step-products";
import SaleStepSummary from "../components/sale-step-summary";
import SaleStepPayment from "../components/sale-step-payment";
import { instanceMob } from "../../../utils/utils";
import "./styles.css";
import {getBackendError} from "../../../utils/error-helpers";
import InlineModal from "../../info-modal/infoModal";

const SaleModal = ({ show, onClose }) => {
    const [step, setStep] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [infoModal, setInfoModal] = useState(null);

    const [saleData, setSaleData] = useState({
        userInfo: {},
        cart: [],
        summary: {},
        payment: {},
    });

    const handleFinish = (finalSale) => {
        setIsSubmitting(true);

        const isPartial = finalSale.payment?.payment_form === 10;
        const isOtherMethod = finalSale.payment?.payment_method === 50;

        const payload = {
            registry_number: finalSale.userInfo?.registry_number,
            customer_id: finalSale.userInfo?.customerId,
            none_customer: finalSale.userInfo?.none_customer,
            location_id: finalSale.userInfo?.locationId,
            value_to_paid: finalSale.payment?.total,
            payment_form: finalSale.payment?.payment_form,
            payment_method: finalSale.payment?.payment_method,
            other_payment_method: isOtherMethod ? finalSale.payment?.entity : "",
            sale_concept: finalSale.userInfo?.saleConcept || "Venta",
            products: finalSale.cart.map((item) => ({
                product_id: item.product_id,
                quantity: item.quantity,
            })),
        };

        if (isPartial) {
            payload.partial_value = finalSale.payment?.partial_value;
        }

        instanceMob
            .post("admin/accounting/sale/create", payload)
            .then((res) => {
                console.log("✅ Venta creada:", res.data);
                setInfoModal({
                    iconType: "success",
                    title: "Venta Creada",
                    description: "La venta se registró exitosamente.",
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => {
                            setInfoModal(null);
                            onClose();
                        },
                    },
                });
            })
            .catch((err) => {
                const errorMessage = getBackendError(err);
                setInfoModal({
                    iconType: "error",
                    title: "Error al Guardar",
                    description: errorMessage,
                    secondaryAction: {
                        label: "Cerrar",
                        onClick: () => setInfoModal(null),
                    },
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const handleNext = (data) => {
        if (data.none_customer !== undefined) {
            data.none_customer = data.none_customer === "true" || data.none_customer === true;
        }
        if (step === 1) {
            setSaleData((prev) => ({ ...prev, userInfo: data }));
            setStep(2);
        } else if (step === 2) {
            setSaleData((prev) => ({ ...prev, cart: data }));
            setStep(3);
        } else if (step === 3) {
            setSaleData((prev) => ({
                ...prev,
                cart: data.products,
                summary: data,
            }));
            setStep(4);
        } else if (step === 4) {
            setSaleData((prev) => {
                const updated = { ...prev, payment: data };
                handleFinish(updated);
                return updated;
            });
        }
    };

    const handleBack = () => setStep((prev) => prev - 1);

    return (
        <>
            {step === 1 && (
                <SaleStepUserInfo
                    show={show}
                    onClose={onClose}
                    data={saleData.userInfo}
                    onNext={handleNext}
                />
            )}
            {step === 2 && (
                <SaleStepProducts
                    show={show}
                    onClose={onClose}
                    data={saleData.cart}
                    onNext={handleNext}
                    onBack={handleBack}
                />
            )}
            {step === 3 && (
                <SaleStepSummary
                    show={show}
                    onClose={onClose}
                    data={saleData.cart}
                    onNext={handleNext}
                    onBack={handleBack}
                />
            )}
            {step === 4 && (
                <SaleStepPayment
                    show={show}
                    onClose={onClose}
                    data={saleData.payment}
                    total={saleData.cart.reduce(
                        (acc, item) => acc + (item.sale_price_per_unit ?? item.price) * (item.quantity ?? 1),
                        0
                    )}
                    noneCustomer={saleData?.userInfo?.none_customer}
                    onNext={handleNext}
                    onBack={handleBack}
                    loading={isSubmitting}
                />
            )}

            {infoModal && (
                <InlineModal
                    iconType={infoModal.iconType}
                    title={infoModal.title}
                    description={infoModal.description}
                    primaryAction={infoModal.primaryAction}
                    secondaryAction={infoModal.secondaryAction}
                />
            )}
        </>
    );
};

export default SaleModal;
